import { Component, effect, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUserService } from '@core/services/current-user.service';

@Component({ template: '', selector: 'app-user-redirect' })
export class UserRedirectComponent {
  #currentUserService = inject(CurrentUserService);
  #router = inject(Router);
  #route = inject(ActivatedRoute);

  public constructor() {
    // HACK: Page that requires a signed in user will be redirected here.
    // We will then wait for the current user to be set before redirecting to the original page.
    // We need to do this because EvC authservice won't initialize if the a Guard waiting for the auth hits before the app component inits.
    effect(() => {
      const currentUser = this.#currentUserService.currentUser();
      if (currentUser) {
        this.#router.navigateByUrl(this.#route.snapshot.queryParams.returnUrl || '/', { replaceUrl: true });
      }
    });
  }
}
